"use client";
import Link from "next/link";
import { useRouter } from "next/navigation";
import { ComponentProps, useCallback } from "react";

const PrefetchLink = ({
  href,
  children,
  ...props
}: ComponentProps<typeof Link>) => {
  const router = useRouter();

  const prefetch = useCallback(() => {
    router.prefetch(href.toString());
  }, [href, router]);
  return (
    <Link prefetch={false} onMouseEnter={prefetch} href={href} {...props}>
      {children}
    </Link>
  );
};

export default PrefetchLink;
